import React from 'react'
import utils from '../../utils'
import { Link } from 'react-router-dom'
import hero from '../../assets/hero.jpeg'

function HomeHero() {
    return (
        <section className="relative h-[63vh] min-h-[550px] flex items-center justify-start overflow-hidden">
            <div className="absolute inset-0 z-0">
                <img
                    alt="Modern furnished apartment in Kisumu with Lake Victoria view"
                    className="w-full h-full object-cover"
                    src={hero}
                />
                <div className="absolute inset-0 bg-gradient-to-r from-[#1B4D3E]/90 via-[#1B4D3E]/60 to-transparent z-10"></div>
            </div>
            <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-12">
                <div className="max-w-2xl">
                    <span className="inline-block text-xs uppercase tracking-widest text-orange-400 mb-4 font-semibold">
                        Welcome to {utils.siteName}
                    </span>

                    <h1 className="text-4xl md:text-6xl lg:text-7xl font-serif font-bold text-white leading-tight mb-6">
                        Your Home across <br />
                        <span className="text-orange-400 italic">Kenya</span>, Sorted.
                    </h1>

                    <p className="text-base md:text-lg text-white/90 mb-10 max-w-lg leading-relaxed">
                        Fully furnished apartments for short or long stays. Event spaces. Catering.
                        All with 24/7 support, Wi-Fi, and the scenic views you've been looking for.
                    </p>

                    <div className="flex flex-wrap gap-4">
                        <Link
                            to="/houses"
                            className="bg-[#E87A25] text-white px-8 py-3.5 rounded-xl text-xs uppercase tracking-widest font-bold hover:bg-[#d17135] transition-all shadow-md"
                        >
                            Browse Apartments
                        </Link>
                        <Link
                            to="/services"
                            className="bg-white/10 backdrop-blur-sm border border-white/30 text-white px-8 py-3.5 rounded-xl text-xs uppercase tracking-widest font-bold hover:bg-white hover:text-[#1B4D3E] transition-all"
                        >
                            See Event Services
                        </Link>
                    </div>
                    <div className="mt-10 flex flex-wrap gap-6 text-white/70 text-xs">
                        <span className="flex items-center gap-2">
                            <span className="text-orange-400">✓</span> 13+ Units
                        </span>
                        <span className="flex items-center gap-2">
                            <span className="text-orange-400">✓</span> M-Pesa Accepted
                        </span>
                        <span className="flex items-center gap-2">
                            <span className="text-orange-400">✓</span> Free Wi-Fi
                        </span>
                        <span className="flex items-center gap-2">
                            <span className="text-orange-400">✓</span> 24/7 Support
                        </span>
                    </div>

                </div>
            </div>
        </section>
    )
}

export default HomeHero